import React from 'react';
import { Star, Check } from 'lucide-react';
import { testimonials, getTestimonialAvatar } from '../data/mock';
import { Card, CardContent } from '../components/ui/card';

const TestimonialsSection = ({ title = "Témoignages de Clients Satisfaits du Grand Marabout" }) => (
  <section className="py-10 bg-zinc-950" id="temoignages">
    <div className="container mx-auto px-4">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-4xl font-bold mb-3 bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 bg-clip-text text-transparent">
          {title}
        </h2>
        <p className="text-base md:text-lg text-amber-100/70">
          Avis WhatsApp vérifiés de personnes ayant retrouvé leur ex
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
        {testimonials.map((testimonial) => {
          const avatar = getTestimonialAvatar(testimonial.name);
          return (
            <Card
              key={testimonial.name}
              className="bg-gradient-to-br from-zinc-900 to-black border-amber-600/30 hover:border-amber-500/60 transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-amber-500/20"
            >
              <CardContent className="p-4 md:p-5">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 bg-gradient-to-br ${avatar.gradient} rounded-full flex items-center justify-center shadow-lg`}>
                      <span className="text-white font-bold text-sm">{avatar.initials}</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-amber-300 text-sm">{testimonial.name}</h4>
                      <p className="text-xs text-amber-100/50">{testimonial.city} - Il y a {testimonial.date}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-1 bg-green-600/20 px-2 py-1 rounded-full border border-green-500/30">
                    <Check size={12} className="text-green-400" />
                    <span className="text-xs text-green-400 font-semibold">Vérifié</span>
                  </div>
                </div>
                
                <div className="flex mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={`star-${testimonial.name}-${i}`} size={14} className="fill-amber-400 text-amber-400" />
                  ))}
                </div>
                
                <p className="text-amber-100/80 text-xs md:text-sm leading-relaxed italic">
                  "{testimonial.message}"
                </p>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
